"use strict";
/**
 * Single source of truth for token cooldown display: timer format and chip label.
 * Used by RunRunnitButton, SetupSession launch, ExtendSessionTimerDialog, and CooldownProgressMenu.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCooldownTimeBucketShort = getCooldownTimeBucketShort;
exports.formatCooldownTimer = formatCooldownTimer;
exports.getCooldownChipLabel = getCooldownChipLabel;
/** Match leading digits and trailing unit (e.g. "5min", "12hr", "1day"). */
const BUCKET_SHORT_REGEX = /^(\d+)([a-zA-Z]+)$/;
/**
 * Short label for cooldown time bucket: "5min" → "5m", "2hr" → "2h", "1day" → "1d".
 * Derives from the bucket string (number + first letter of unit); works with TOKEN_COOLDOWN_TIME_BUCKET enum values.
 */
function getCooldownTimeBucketShort(timeBucket) {
    if (!timeBucket || typeof timeBucket !== 'string')
        return '';
    const matched = timeBucket.match(BUCKET_SHORT_REGEX);
    return matched ? matched[1] + matched[2][0] : timeBucket;
}
/**
 * Format countdown as "4:13 / 5m" or "1:27:00 / 2h". Returns "ready" when totalSeconds <= 0.
 */
function formatCooldownTimer(totalSeconds, timeBucketShort) {
    if (totalSeconds <= 0)
        return 'ready';
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    const pad = (n) => (n < 10 ? '0' + n : String(n));
    const timerPart = h >= 1 ? `${h}:${pad(m)}:${pad(s)}` : m >= 1 ? `${m}:${pad(s)}` : String(s);
    return timeBucketShort ? `${timerPart} / ${timeBucketShort}` : timerPart;
}
/**
 * Chip label when blocked by cooldown: "over max budget" if cost > threshold or no timer, else the timer text.
 */
function getCooldownChipLabel(cost, threshold, timerText) {
    if (cost == null || typeof threshold !== 'number')
        return '';
    if (cost > threshold)
        return 'over max budget';
    return timerText || 'over max budget';
}
